// extracted by mini-css-extract-plugin
export default {"container":"ephLjq","arrow":"z0GBQl","page":"s8kmwa","active":"VbZ5je"};